import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface PageHeroProps {
  title: string;
  subtitle?: string;
  eyebrow?: string;
  children?: ReactNode;
  breadcrumb?: { label: string; to?: string }[];
}

export default function PageHero({ title, subtitle, eyebrow, children, breadcrumb }: PageHeroProps) {
  return (
    <section className="relative w-full bg-primary-950 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.35]">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20navy%20textured%20backdrop%20with%20subtle%20diagonal%20golden%20light%20streaks%2C%20soft%20film%20grain%2C%20deep%20indigo%20gradient%2C%20minimal%20premium%20cinematic%20atmosphere%2C%20no%20text%2C%20no%20people&width=1600&height=520&seq=page-header-texture&orientation=landscape"
          alt="页面背景装饰图"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950 via-primary-950/90 to-primary-900/70" />
      <div className="relative w-full px-4 md:px-8 py-10 md:py-14">
        {breadcrumb && (
          <nav className="flex items-center gap-1.5 text-[12px] text-background-400 mb-4 flex-wrap">
            {breadcrumb.map((item, index) => (
              <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
                {index > 0 && <i className="ri-arrow-right-s-line text-[11px]" />}
                {item.to ? (
                  <Link to={item.to} className="hover:text-accent-300 transition-colors">
                    {item.label}
                  </Link>
                ) : (
                  <span className="text-background-200">{item.label}</span>
                )}
              </span>
            ))}
          </nav>
        )}
        {eyebrow && (
          <p className="text-[11px] tracking-[0.3em] uppercase text-accent-400 mb-2">{eyebrow}</p>
        )}
        <h1 className="font-heading text-2xl md:text-4xl font-semibold text-background-50 leading-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-3 max-w-3xl text-sm md:text-[15px] leading-relaxed text-background-300">
            {subtitle}
          </p>
        )}
        {children}
      </div>
    </section>
  );
}